<tui-root [attr.tuiTheme]="darkMode ? 'dark' : 'light'">
  <!-- Session warning component disabled - popup removed as per requirement -->
  <!-- <app-session-warning /> -->
  <app-layout-wrapper />
</tui-root>
<app-global-notification />
